import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TaskPage } from './task';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    TaskPage,
  ],
  imports: [
    IonicPageModule.forChild(TaskPage),
    CalendarModule,
    NgxPaginationModule,
  ],

  entryComponents: [
  ],
  providers: [
    RestProvider,
  ]
})
export class TaskPageModule {}



// WEBPACK FOOTER //
// ./src/pages/task/task.module.ts